import { Theme, css } from '@emotion/react';

export const formLabelQualifier = ({ spacing }: Theme) => css`
  margin-left: ${spacing(0.25)}px;
`;
